































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import InformationIcon from 'mdi-vue/InformationOutline';
import SearchField from '@/components/SearchField.vue';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import TagInput from '@/components/TagInput.vue';
import Loader from '@/components/Loader.vue';
import FormInput from '@/components/FormInput.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
import Modal from '@/components/Modal.vue';
// import axios from 'axios';
import Select from '@/components/Select.vue';
import Button from '@/components/Button.vue';
import CloseIcon from 'mdi-vue/Close';
import DownloadIcon from 'mdi-vue/Download';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import numberFormat from '@/libs/numberFormat';
import { ValidationObserver } from 'vee-validate';
import Toggle from '@/components/Toggle.vue';
import FileInput from '@/components/FileInput.vue';
import axios from 'axios';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';

@Component({
  components: {
    ValidationObserver,
    LayoutTitle,
    LayoutContent,
    StatusIndicator,
    Loader,
    SearchField,
    TagInput,
    Select,
    FormInput,
    Button,
    Modal,
    CloseIcon,
    Toggle,
    InformationIcon,
    FileInput,
    DownloadIcon,
    ScrollbarWrapper,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
  },
  methods: {
    numberFormat,
  },
})

export default class AccountManagementReseller extends Vue {
loadingForSubMerchant = false;
loadingGenerateCode = false;
loadingChangeStatusCode = false;
showModalGenerateReferralCode = false;
showModalAddSubMerchant = false;
loading = false;
roles = '';
referralCode = '';
referralCodes: any = [];
merchantResellers: any = [];
isMerchantReseller = true;

referralCodeOptions: any = [];

referralCodeSelected: { label: string; value: string } | null = null;

forSubMerchant = [
  {
    /* eslint-disable @typescript-eslint/camelcase */
    merchant_code: '',
    merchant_name: 'Enter merchant name',
    $isDisabled: true,
    /* eslint-enable @typescript-eslint/camelcase */
  },
];

mounted() {
  this.roles = JSON.parse(localStorage.getItem('USER') || '{}').user.user_role.role;
  this.getData();
}

getData() {
  this.getReferralCode();
  this.getMerchantReseller();
}

forSubMerchantSelected: { merchant_code: string; merchant_name: string } | null = null;

// eslint-disable-next-line class-methods-use-this
dateFormat(time: string) {
  const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
  if (formatted === 'Invalid Date') {
    return '-';
  }

  return formatted;
}

close() {
  this.showModalGenerateReferralCode = false;
}

closeModalAddSubMerchant() {
  this.showModalAddSubMerchant = false;
}

showModalGenerateReferralCodes() {
  this.showModalGenerateReferralCode = true;
}

async generateReferralCode() {
  this.loading = false;
  const id = this.$route.params.type;
  try {
    this.loadingGenerateCode = true;
    await api.post('/res/referral-code', {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: id,
      referral_code: this.referralCode,
    });
    this.getData();
    showToast(ToastType.SUCCESS, 'Success', 'Referral Code Generated');
  } catch (err) {
    this.loading = false;
    console.error(err);
    showToast(ToastType.FAILED, 'Error', (err as any).response.data.error.errors.map((e: any) => e.message));
  }
  this.loadingGenerateCode = false;
  this.showModalGenerateReferralCode = false;
}

showModalAddSubMerchants() {
  this.showModalAddSubMerchant = true;
}

async addSubMerchant() {
  this.showModalAddSubMerchant = false;
}

async changeRefCodeStatus(ref_code: string, ref_code_status: string) {
  this.loading = false;
  this.loadingChangeStatusCode = true;
  await api.put('/res/referral-code-status', {
    /* eslint-disable @typescript-eslint/camelcase */
    referral_code: ref_code,
    referral_code_status: ref_code_status,
  });
  // INACTIVE' : 'ACTIVE'
  if (ref_code_status === 'ACTIVE') {
    showToast(ToastType.SUCCESS, 'Success', `Referral Code ${ref_code} status update to ${ref_code_status}`);
  } else {
    showToast(ToastType.FAILED, 'Success', `Referral Code ${ref_code} status update to ${ref_code_status}`);
  }
  this.loadingChangeStatusCode = false;
  this.getData();
}

async getReferralCode() {
  const id = this.$route.params.type;

  try {
    this.loading = true;
    const { data } = await api.get(`/res/referral-code/${id}`);
    this.referralCodes = data;
    this.referralCodeOptions = data;
  } catch (err) {
    console.error(err);
    showToast(ToastType.FAILED, 'Error', (err as any).response.data.error.errors.map((e: any) => e.message));
  }
  this.loading = false;
}

async getMerchantReseller() {
  const id = this.$route.params.type;

  try {
    this.loading = true;
    const { data } = await api.get(`/res/merchant-reseller/${id}`);
    this.merchantResellers = data;
  } catch (err) {
    console.error(err);
    showToast(ToastType.FAILED, 'Error', (err as any).response.data.error.errors.map((e: any) => e.message));
  }
  this.loading = false;
}

async getMerchantsForSubmerchant(query: string, value: string) {
  if (query === '') return;

  try {
    this.loadingForSubMerchant = true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const params: any = {};
    params[query] = value;
    const { data } = await api.get('/consumer/merchant', {
      params,
    });
    this.forSubMerchant = data.data;
    this.loadingForSubMerchant = false;
    console.log();
  } catch (err) {
    console.error(err);
  }
}
}
